import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=d08db21a&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"
import style0 from "./pagination.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pagination.vue?vue&type=style&index=1&id=d08db21a&lang=scss&scoped=true&"
import style2 from "./pagination.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08db21a",
  null
  
)

export default component.exports